module.exports = __webpack_public_path__ + "static/img/pay.90d64a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/onboarding/views/pay/images/pay.svg
// module id = jxrO
// module chunks = 12